import React, { Component } from 'react';
import DataTableHeader from "./DataTableHeader";
import DataTableBody from "./DataTableBody";

export default class DataTable extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <table>
                <DataTableHeader columns={this.props.columns} option={this.props.option} />
                <DataTableBody columns={this.props.columns} rows={this.props.rows} option={this.props.option} />
            </table>
        );
    }
}
